import { alpha, Chip } from '@mui/material';

export type PaymentStatusChipProps = {
  status:
    | 'Draft'
    | 'Pending Approval'
    | 'In Progress'
    | 'Completed'
    | 'Reject'
    | 'Request to Cancel'
    | 'Cancel'
    | 'Pending'
    | 'Pending Release Payment'
    | 'Suspended'
    | 'Partially Cancelled'
    | 'Refunded'
    | string;
};

const statusMap = {
  Draft: {
    label: 'Draft',
    color: '#F0AD00',
  },
  'Pending Approval': {
    label: 'Pending Approval',
    color: '#F0AD00',
  },
  'In Progress': {
    label: 'In Progress',
    color: '#3D5AFE',
  },
  Completed: {
    label: 'Completed',
    color: '#67CA24',
  },
  Rejected: {
    label: 'Rejected',
    color: '#FF4D49',
  },
  'Request to Cancel': {
    label: 'Request to Cancel',
    color: '#FF4D49',
  },
  Cancel: {
    label: 'Cancel',
    color: '#F05A5A',
  },
  Cancelled: {
    label: 'Cancelled',
    color: '#F05A5A',
  },
  Pending: {
    label: 'Pending',
    color: '#F0AD00',
  },
  'Pending Release Payment': {
    label: 'Pending Release Payment',
    color: '#F0AD00',
  },
  Suspended: {
    label: 'Suspended',
    color: '#F05A5A',
  },
  Refunded: {
    label: 'Refunded',
    color: '#F05A5A',
  },
  Failed: {
    label: 'Failed',
    color: '#F05A5A',
  },
  'Partially Cancelled': {
    label: 'Partially Cancelled',
    color: '#F0AD00',
  },
};

export const PaymentStatusChip: React.FC<PaymentStatusChipProps> = (props) => {
  const { status } = props;
  // ======================= VIEWS
  return (
    <Chip
      variant="filled"
      size="small"
      label={statusMap?.[status]?.label || ''}
      sx={{
        fontWeight: 600,
        color: statusMap?.[status]?.color || '#FFFFFF',
        backgroundColor: alpha(statusMap?.[status]?.color || '#FFFFFF', 0.12),
      }}
    />
  );
};

// ======================= EXPORT
export default PaymentStatusChip;
